import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';
import React, {
  useCallback, useMemo, useState,
} from 'react';

export const Switch = ({
  options, value = options[0], onChange, nameKey, renderItem, background, wrapperStle,
}) => {
  const [hover, setHover] = useState(false);

  const activeIndex = options.findIndex((e) => e.value === value);

  const [optionsContainer, setOptionsContainer] = useState(null);
  const activeOptionNode = useMemo(() => optionsContainer?.childNodes.item(activeIndex), [activeIndex, optionsContainer?.childNodes]);

  const getItemName = useCallback(
    (item) => {
      if (renderItem) {
        return renderItem(item);
      }

      if (typeof item === 'string') {
        return item;
      }
      if (item && nameKey !== undefined) {
        return item[nameKey];
      }

      return '';
    },
    [nameKey, renderItem],
  );

  return (
    <div
      style={{
        position: 'relative',
        display: 'block',
        borderRadius: '1em',
        background: 'rgba(0, 0, 0, 0.2)',
        alignSelf: 'baseline',
        ...(wrapperStle || {}),
      }}
      onMouseLeave={() => setHover(false)}
      onBlur={() => setHover(false)}
    >
      {activeOptionNode && (
        <motion.div
          style={{
            position: 'absolute',
            background: 'white',
            borderRadius: '1em',
            color: '#4a4a4a',
            height: '100%',
            fontSize: '0.95em',
            top: '0',
            transition: 'box-shadow 0.2s ease-out',
            boxShadow: hover ? 'rgb(217,217,217) 0px 0px 0px 1px, rgb(217,217,217, 0.4) 0px 0px 0px 0.4em' : 'rgb(217 217 217) 0px 0px 0px 1px',
          }}
          initial={{
            left: activeOptionNode.offsetLeft,
            width: activeOptionNode.clientWidth,
          }}
          animate={{
            left: activeOptionNode.offsetLeft,
            width: activeOptionNode.clientWidth,
          }}
          transition={{
            duration: 0.2,
            ease: 'easeOut',
          }}
        />
      )}
      <div
        ref={(current) => setOptionsContainer(current)}
        style={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'row',
        }}
      >
        {options.map((option, index) => (
          <div
            key={index}
            style={{
              flex: '0 0 auto',
              lineHeight: '2',
              whiteSpace: 'nowrap',
              color: '#4a4a4a',
              fontSize: '0.95em',
              padding: '0.1em 1em',
              background: 'transparent',
              cursor: 'pointer',
            }}
            onClick={() => {
              onChange(options[index].value);
            }}
            onMouseEnter={() => setHover(index === activeIndex)}
            onMouseLeave={index === activeIndex ? () => setHover(false) : undefined}
            onBlur={index === activeIndex ? () => setHover(false) : undefined}
          >
            {getItemName(option)}
          </div>
        ))}
      </div>
    </div>
  );
};
